<template>
  <div class="recipe-table">
    <Table
      v-if="finalRecipe && finalRecipe.detail && finalRecipe._id"
      :columns="dynamicColumns"
      :data="displayData"
      size="small"
      border
    >
      <template slot-scope="{ row }" slot="name">
        <span v-if="row.type === 'semi'">{{ row.model }}</span>
        <span class="span-name" v-else>{{ row.name }}</span>
      </template>
      <template slot-scope="{ row, index }" slot="ratio">
        <span
          v-if="row.type === 'sumrow'"
          :class="{
            sumratio: true,
            'sumratio-alert': sumRatio > 100,
            'sumratio-nice': sumRatio === 100,
          }"
          >{{ row.ratio }}</span
        >

        <InputNumber
          v-else-if="mode.ratio.edit"
          :max="100"
          :min="0"
          :step="0.1"
          v-model="finalRecipe.detail[index].ratio"
          class="input-ratio"
        />
        <span v-else class="span-ratio" style="line-height: 32px">{{
          (finalRecipe.detail[index].ratio * 100).toFixed(2)
        }}</span>
        <span class="percentage-append">%</span>
      </template>

      <template slot-scope="{ row }" slot="deleteBtn" style="padding-left: 0">
        <Icon
          v-if="row.type !== 'sumrow'"
          type="ios-remove-circle-outline"
          class="deleteBtn"
          @click="removeMaterialfromRecipe(row._id)"
          size="24"
        />
      </template>
      <template slot-scope="{ row, index }" slot="volPlan">
        <span v-if="row.type === 'sumrow'" :class="{ sumratio: true }">{{
          totalQuantity
        }}</span>
        <InputNumber
          v-else-if="mode.volPlan.edit"
          :max="100"
          :min="0"
          :step="0.1"
          v-model="finalRecipe.detail[index].volPlan"
        />
        <span v-else class="span-ratio" style="line-height: 32px">{{
          (finalRecipe.detail[index].ratio * totalQuantity).toFixed(2)
        }}</span>
      </template>
    </Table>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  name: "RecipeTable",
  components: {},
  props: {
    recipe: [Object, String],
    type: String, // should be 'semi' or 'sales'
    totalQuantity: Number,
    ratio_display: Boolean,
    ratio_edit: Boolean,
    volPlan_display: Boolean,
    volPlan_edit: Boolean,
    quantityActual_display: Boolean,
    quantityActual_edit: Boolean,
  },
  data() {
    return {
      finalRecipe: null,
      columns: {
        name: {
          title: "原材料",
          slot: "name",
          render: (h, params) => {
            return h(
              "span",
              params.row.model ? params.row.model : params.row.name
            );
          },
        },
        ratio: {
          title: "比例",
          slot: "ratio",
          align: "right",
          width: 130,
        },
        deleteBtn: {
          title: " ",
          slot: "deleteBtn",
          align: "left",
          width: 40,
        },
        volPlan: {
          title: "计划数量（吨）",
          slot: "volPlan",
          align: "right",
        },
      },
      errMsg: null,
    };
  },
  computed: {
    sumRatio: function () {
      return this.finalRecipe.detail.reduce(
        (sum, row) => sum + (row.ratio || 0),
        0
      );
    },
    displayData: function () {
      return [
        ...this.finalRecipe.detail,
        {
          name: "总和",
          ratio: this.mode.ratio.edit
            ? this.sumRatio
            : (this.sumRatio * 100).toFixed(2),
          type: "sumrow",
          quantity: this.totalQuantity ? this.totalQuantity : 0,
        },
      ];
    },
    dynamicColumns: function () {
      let col = [this.columns.name];
      if (this.mode.ratio.display) col.push(this.columns.ratio);
      if (this.mode.volPlan.display) col.push(this.columns.volPlan);
      if (this.mode.ratio.edit) col.push(this.columns.deleteBtn);
      return col;
    },
    mode: function () {
      const mode = {
        ratio: {
          display: this.ratio_display || true,
          edit: this.ratio_edit || false,
        },
        volPlan: {
          display: this.volPlan_display || false,
          edit: this.volPlan_edit || false,
        },
        quantityActual: {
          display: this.quantityActual_display || false,
          edit: this.quantityActual_edit || false,
        },
      };
      return mode;
    },
  },
  methods: {
    ...mapActions({
      getRecipeSemisById: "recipeSemi/getRecipeSemisByIdAction",
      getRecipeSalesById: "recipeSales/getRecipeSalesByIdAction",
    }),
    async loadRecipe(recipe, type) {
      this.errMsg = null;
      this.finalRecipe = null;
      if (recipe) {
        try {
          if (type === "semi") {
            this.finalRecipe = await this.getRecipeSemisById(recipe);
          } else {
            this.finalRecipe = await this.getRecipeSalesById(recipe);
          }
        } catch (error) {
          this.errMsg = error;
        }
      } else {
        this.finalRecipe = recipe;
      }
    },
  },
  created() {},
};
</script>

<style scoped lang="stylus">
.recipe-table
  width 100%

.input-ratio
  width 75px
  float left
  text-align right
  margin-right 4px

.percentage-append
  float right
  line-height 32px
  height 32px

.sumratio
  line-height 32px
  font-size 16px
  margin-right 4px

.sumratio-alert
  color red

.sumratio-nice
  color green

.deleteBtn
  cursor pointer

  &:hover
    color red

.span-ratio
  font-size 14px
  margin-right 4px

.span-name
  font-size 14px
</style>
